export enum DocumentType {
  PDF = 'pdf',
  PNG = 'png',
  JPG = 'jpg',
  JPEG = 'jpeg',
  DOC = 'doc',
  DOCX = 'docx',
}

export const DocumentMimeTypes: Record<DocumentType, string> = {
  [DocumentType.PDF]: 'application/pdf',
  [DocumentType.PNG]: 'image/png',
  [DocumentType.JPG]: 'image/jpeg',
  [DocumentType.JPEG]: 'image/jpeg',
  [DocumentType.DOC]: 'application/msword',
  [DocumentType.DOCX]:
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
};

export const DocumentExtensions: string[] = [
  '.pdf',
  '.png',
  '.jpg',
  '.jpeg',
  '.doc',
  '.docx',
];
export function isSupportedDocumentType(mimeType: string): boolean {
  return Object.values(DocumentMimeTypes).includes(mimeType);
}

export function getDocumentTypeFromMime(mimeType: string): DocumentType | null {
  const entries = Object.entries(DocumentMimeTypes);
  for (const [type, mime] of entries) {
    if (mime === mimeType) {
      return type as DocumentType;
    }
  }
  return null;
}

export function getDocumentTypeFromExtension(
  extension: string
): DocumentType | null {
  const ext = extension.toLowerCase().replace('.', '');
  if (Object.values(DocumentType).includes(ext as DocumentType)) {
    return ext as DocumentType;
  }
  return null;
}
